import { motion } from "framer-motion";
import { MapPin, Phone } from "lucide-react";

export const Banner = ({ onApply }) => {
  return (
    <section id="showroom" className="py-24 md:py-32 bg-oed-surface border-y border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <p className="text-xs uppercase tracking-[0.3em] text-oed-gold mb-6">Visit Our Showroom</p>
          <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl leading-[1.05]">
            See it. Experience it. <span className="text-oed-gold">Live it.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-white/60 leading-relaxed max-w-md">
            Your one-stop shop for off-grid living &amp; investment solutions — tiny homes, geo domes,
            solar power, battery storage, water systems, outdoor living &amp; more.
          </p>
          <div className="mt-8 space-y-4">
            <p className="flex items-start gap-3 text-white/70">
              <MapPin size={18} className="mt-0.5 shrink-0 text-oed-gold" />
              43106 US Hwy 280, Lineville, AL 36266
            </p>
            <a href="tel:2562687146" data-testid="banner-phone" className="flex items-center gap-3 text-white/70 hover:text-oed-gold transition-colors">
              <Phone size={18} className="text-oed-gold" /> Call or text — 256-268-7146
            </a>
          </div>
          <button
            data-testid="banner-apply-button"
            onClick={onApply}
            className="mt-9 bg-oed-gold text-black px-8 py-4 text-sm font-medium tracking-wide hover:bg-oed-goldHover transition-colors"
          >
            Start Your Off-Grid Journey
          </button>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <div className="border border-white/10 p-2 bg-oed-base">
            <img
              src="/banner.png"
              alt="OED Glampire Network — Live Off-Grid, Live Freely. Off-grid living & investment solutions."
              className="w-full h-auto"
              data-testid="showroom-banner-image"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
